import { z } from "zod";

export const ReadmeLoginResponseBodySchema = z.object({
  redirect: z.string(),
});
export type ReadmeLoginResponseBodyType = z.infer<
  typeof ReadmeLoginResponseBodySchema
>;
